module.exports = __webpack_public_path__ + "h5/img/rank_bg.57795430.png";